import { Button, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@material-ui/core';
import React, { useEffect } from 'react';
import Chart from "react-google-charts";
import { useDispatch } from 'react-redux';

import data from '../../app/api/fan.json'
import { useAppSelector } from '../../app/hooks';
import { changeTorqueCurvePoint ,getFanDetails } from '../../app/reducer/project.reducer';
import { searchFunction1 } from '../general/utils';

export default function TorqueCurve({...props}:any) {
    const [graphData, setGraphData] = React.useState<any[]>([]);
    const dispatch = useDispatch();
    const fanDetails = useAppSelector(getFanDetails);

    useEffect(() => {

      populateGraphDataFromProps()

    }, [props.data]);

    const onPlotpointChage = (index:number,value:number) => {

      dispatch(changeTorqueCurvePoint({index:index-1,value}))

    }
    
    const populateGraphDataFromProps = async () => {

      const { fanData, fanDetailsInput } = props;

      let { rpm,fanDiameter } = fanData;
      let { fan_speed,pressure_type } = fanDetailsInput;
      rpm = fan_speed?fan_speed:rpm;
      // console.log(rpm,fan_speed)
      const { req_airflow, pressure,air_density } = fanDetailsInput;
      console.log(fanDetailsInput)
      /*const d45 = searchFunction1(fanData.performance_curves, req_airflow);
      console.log("TOTA:", req_airflow, d45);
      const d39 = (parseFloat(req_airflow) * parseFloat(pressure) * 10) / d45;*/
      const d1 = fanDetails.fan_diameter ? parseFloat(fanDetails.fan_diameter) : fanDiameter;
      const d2 = fanDetails.fan_ring_diameter ? fanDetails.fan_ring_diameter : (d1 + (d1 * 2 * 0.0045)).toFixed(3);
      const d31 = 3.14 * (Math.pow(d2, 2) - Math.pow(fanData.hub.hubDiameter, 2)) / 4;
      console.log(air_density)
      const pvValue = Math.pow((req_airflow / d31), 2) * 0.5 * (parseFloat(air_density));
      const d34 = req_airflow
      const d38 = pressure_type=='static'? Number(pressure)+Number(pvValue):pressure;
      console.log(pressure_type,d38)
      const d45 = fanData.designPoint?.expectedEfficiency ;
      const d39 = d34 * d38 * 0.1 / d45;

      let tempGraphData = [];

      let graphHeaderData = ['RPM%','Torque'] 
      let TorqueBreakpoints = [100,90,80,70,60,50,40,30,20,10,0]
      tempGraphData.push(graphHeaderData);

      for (let i = 0; i < TorqueBreakpoints.length; i++) {
        
        let GraphDataRow = [];
        GraphDataRow.push(TorqueBreakpoints[i])

        let fsp =d39
        let M = rpm * (TorqueBreakpoints[i]/100);
        let L =(M / rpm) ** 3 * fsp;
        let J = L / 0.745
        let torque = 4500*J/(2*3.14* M)
        if(i==0)
        {
        console.log("torque params",L,rpm,d34,d38,d45)
        console.log(" l , m , j ,fsp",L,M,J,fsp)
        }
        /*let tc1 = rpm * (TorqueBreakpoints[i]/100) * (TorqueBreakpoints[i]/100) * (TorqueBreakpoints[i]/100);
        let tc3 = d39 * 0.745;
        let hp = tc3 * ((TorqueBreakpoints[i]/100) * tc1/tc1) ** 3;
        let torque = 4500 * hp / (2 * 3.14* rpm)*/
        

        GraphDataRow.push(torque)

        tempGraphData.push(GraphDataRow);

      }

      setGraphData(tempGraphData);
      // console.log("Torque Curve",tempGraphData)

    }
    
  
  if(props.onlyGraph){
    return(
      <Chart
        width={'100%'}
        height={'800px'}
        chartType="LineChart"
        loader={<div>Loading Chart</div>}
        data={
          graphData
          // [
          //   [ 'RPM%', 'Torque'],
          //   [ '100', 201.2373192 ],
          //   [ '90', 163.0022286 ],
          //   [ '80', 128.7918843 ],
          //   [ '70', 98.60628641 ],
          //   [ '60', 72.44543491 ],
          //   [ '50', 50.3093298 ],
          //   [ '40', 32.19797107 ],
          //   [ '30', 18.11135873 ],
          //   [ '20', 8.049492768 ],
          //   [ '10', 2.012373192],
          //   [ '0', 0]
          // ]
        }
        options={{
          legend: {
    textStyle: {
      fontSize: 17, // 🔥 increase this
    },
  },
          hAxis: {
            title: 'RPM%',
            direction: 1,
            textStyle: {
        fontSize: 22, // 🔹 x-axis labels
      },
      titleTextStyle: {
        fontSize: 18, // 🔹 x-axis title
        bold: true,
      },
          },
          vAxis: {
            title: 'Torque (kgf-m)',
            textStyle: {
        fontSize: 22, // 🔹 x-axis labels
      },
      titleTextStyle: {
        fontSize: 18, // 🔹 x-axis title
        bold: true,
      },
          },
          series: {
            1: { curveType: 'function' }
          },
        }}
      />
    )
  }else{
    return (
      <div style={{
        display:'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '1200px',
        padding: '0px'
      }}>
        <Typography variant="h5" gutterBottom>
          <b>Torque Curve Table</b>
        </Typography>
        <Typography variant="h6" gutterBottom>
          <b>Fan Model: {props.fanData.fanModelID}</b>
        </Typography>
        <Typography variant="h6" gutterBottom>
          <b>RPM: {fanDetails.fan_speed??props.fanData.rpm}</b>
        </Typography>
        {/* <TableContainer style={{width:'200px'}}> */}
          <Table aria-label="simple table" size="small" style={{zoom:0.8}}>
            <TableHead>
                <TableRow>
                <TableCell align="right"><Typography variant="h5">RPM</Typography></TableCell>
                {graphData.map((row,index) => (
                  (index!==0?
                    <TableCell component="th" scope="row" key={row[0]}>
                      <Typography variant="h5">{row[0]}</Typography>
                    </TableCell>
                  :null)
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
              <TableCell align="right"><Typography variant="h5">Torque (kgf-m)</Typography></TableCell>
              {graphData.map((row,index) => (
                (index!==0?
                  <TableCell align="right"><TextField variant="outlined" placeholder='Blank' type="number"  value={row[1]} disabled /></TableCell>
                :null)
              ))}
              </TableRow>
            </TableBody>
          </Table>
        {/* </TableContainer> */}
        <br/>
        <br/>
        {/* <Divider /> */}
        <br/>
        <Typography variant="h5" gutterBottom>
          <b>Torque Curve Graph</b>
        </Typography><br/>
        <Chart
          width={'100%'}
          height={'500px'}
          chartType="LineChart"
          loader={<div>Loading Chart</div>}
          data={
            graphData
            // [
            //   [ 'RPM%', 'Torque'],
            //   [ '100', 201.2373192 ],
            //   [ '90', 163.0022286 ],
            //   [ '80', 128.7918843 ],
            //   [ '70', 98.60628641 ],
            //   [ '60', 72.44543491 ],
            //   [ '50', 50.3093298 ],
            //   [ '40', 32.19797107 ],
            //   [ '30', 18.11135873 ],
            //   [ '20', 8.049492768 ],
            //   [ '10', 2.012373192],
            //   [ '0', 0]
            // ]
          }
          options={{
            hAxis: {
              title: 'RPM%',
              direction: 1,
              textStyle: {
        fontSize: 22, // 🔹 x-axis labels
      },
      titleTextStyle: {
        fontSize: 18, // 🔹 x-axis title
        bold: true,
      },
            },
            vAxis: {
              title: 'Torque (kgf-m)',
              textStyle: {
        fontSize: 22, // 🔹 x-axis labels
      },
      titleTextStyle: {
        fontSize: 18, // 🔹 x-axis title
        bold: true,
      },
            },
            series: {
              1: { curveType: 'function' }
            },
          }}
        />
        <br/>
          <div
          style={{
            display:'flex',
            flexDirection:'row',
            justifyContent:'flex-start'
          }}>
            <Button
                variant="outlined"
                color="primary"
                size="large"
                onClick={e=>props.setIndex(3)}
                style={{backgroundColor:'#6b6666',color:'white'}}
            >
                Back
            </Button>
            <span style={{padding:'20px'}}/> 
            <Button
                  // type="submit"
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={e=>props.setIndex(5)}
            >
                  Next
            </Button>
          </div>
      </div>
    );
    }
}
